import React, { useState, useEffect } from "react";
import { Button, ModalBody, ModalHeader } from "reactstrap";
import plane from "../../../../assets/images/plane.svg";
import checkImage from "../../../../assets/images/bi_check2-square.svg";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Switch } from "@mui/material";
import navigationAction from "redux/navigation/actions";
import {
  ChangeAutoRenew,
  getSubscriptionAllDetails
} from "services/SubscriptionPackageServices";
import Loader from "components/Loader";
import authActions from "redux/auth/actions";
import CheckoutSubscriptionForm from "./checkoutSubscriptionForm";
import { checkApi } from "services/authServices";
import { Modal } from "reactstrap";
import ConformationModalUser from "components/common/ConformationModalUser";
import {
  cancel_subscription,
  startFreeTrail
} from "services/subscriptionServices";
import { getMerchantProfile } from "services/merchantProfileServices";

const { success, error } = navigationAction;
const { setUser, check } = authActions;

function SubscriptionPage(props) {
  const { user, token } = props;
  const [isAutoRenew, setIsAutoRenew] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checkoutModal, setCheckOutModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [subscribeModal, setSubscribeModal] = useState(false);
  const [subData, setSubData] = useState({});
  const [checkFree, setCheckFree] = useState("");
  const [userData, setUserData] = useState({});
  console.log("subscriber data", userData);

  let isSubscribed =
    new Date(userData?.isCancelledSubscriptionDate) >= new Date() &&
    userData?.subscription_package?.subscription_id
      ? true
      : false;
  // console.log("props in subscription", props);
  // console.log("user in subscription Page", user);
  // console.log("history", props.history);

  const handleAutoRenew = async e => {
    console.log("e target checked", e.target.checked);
    // let autoRenewStatus = e.target.checked;
    let updatedDetails = {
      subscription_id: userData?.subscription_package?.subscription_id,
      autoRenew: e.target.checked
    };
    setLoading(true);
    await ChangeAutoRenew(token, updatedDetails).then(async res => {
      if (res.success) {
        success(res.message);
        // console.log(res.dta);
        await checkApi(token).then(res => {
          if (res.success) {
            // console.log(res.data);
            setUser(res.data);
          } else {
            error(res.message);
          }
        });
        setIsAutoRenew(!isAutoRenew);
      } else {
        error(res.message);
      }
      setLoading(false);
    });
  };

  const getSubscription = async () => {
    await getSubscriptionAllDetails(token).then(res => {
      if (res.success) {
        let newPack = res.data.filter(e => {
          console.log(
            "checkFree",
            // checkFree,
            checkFree === "is_free" ? e.is_free : e.is_free === false
          );
          return checkFree === "is_free" ? e.is_free : e.is_free === false;
        });
        setSubData(newPack[0]);
      }
    });
  };

  const cancelSubscription = async () => {
    setCancelModal(false);
    setLoading(true);
    let data = {
      subscription_id: userData.subscription_package.subscription_id,
      sub_user_id: userData._id
    };
    await cancel_subscription(token, data).then(res => {
      // console.log(res, "res");
      if (res.success) {
        success(res.message);
        setLoading(false);
        window.location.reload();
      } else {
        error(res.message);

        setLoading(false);
      }
    });
  };

  const getMerchantProfileData = async () => {
    await getMerchantProfile(token, user?._id).then(res => {
      if (res.success) {
        setUser(res.data);
        setUserData(res.data);
      }
    });
  };

  const buySubscription = async e => {
    if (checkFree === "is_free") {
      setLoading(true);
      await startFreeTrail(token).then(res => {
        if (res.success) {
          setLoading(false);
          setSubscribeModal(false);
          success(res.message);
          window.location.reload();
        } else {
          error(res.message);
        }
      });
    } else {
      setSubscribeModal(false);
      setCheckOutModal(true);
    }
  };

  useEffect(() => {
    getSubscription();
    getMerchantProfileData();
  }, [!isAutoRenew, checkFree]);

  return (
    <>
      <div className="d-flex flex-row justify-content-center align-items-center  sub-page-container my-3">
        <div
          className="subscription-container"
          style={isSubscribed ? { border: "1px solid #00b94b" } : null}
        >
          <div className="sub-plan-box">
            {isSubscribed ? (
              <span className="badge badge-success active-span">
                <i class="fas fa-check mr-2"></i>Active
              </span>
            ) : null}

            <div className="row">
              <div
                className="col-auto  mt-5 mb-2"
                style={{ margin: "0 auto", color: "#28337f" }}
              >
                {isSubscribed ? (
                  <h4>My Subscribed Plan</h4>
                ) : (
                  <h4>Choose a plan for</h4>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-auto  mb-3" style={{ margin: "0 auto" }}>
                <img src={plane} alt="plane" />
              </div>
            </div>
            <div className="row">
              <div
                className="col-auto mb-5"
                style={{
                  margin: "0 auto",
                  borderRadius: "5px",
                  backgroundColor: "#ffffff"
                }}
              >
                {console.log(subData.price, subData, "check price")}
                {subData.price ? (
                  <>
                    <span style={{ color: "#28337f", fontSize: "30px" }}>
                      ${(subData?.price / 100).toFixed(0)}
                    </span>
                    <span style={{ color: "GrayText" }}>/Month</span>
                  </>
                ) : (
                  <>
                    <span style={{ color: "#28337f", fontSize: "30px" }}>
                      $12
                    </span>
                    <span style={{ color: "GrayText" }}>/Month</span>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div
              className="col-auto my-3"
              // style={{ margin: "0 auto" }}
            >
              <ul className="w-100 mt-2 sub-list">
                <li>
                  <img src={checkImage} alt="" /> AdFree Experience
                </li>
                <li>
                  <img src={checkImage} alt="" /> Updates After Each Call
                </li>
                <li>
                  <img src={checkImage} alt="" /> Auto Backup Call Log On Google
                  Drive
                </li>
                <li>
                  <img src={checkImage} alt="" /> Quick Technical Support
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            {userData.isCancelledSubscription === false ? (
              <>
                {isSubscribed ? (
                  <div className="sub-center">
                    <span>Auto Renew</span>
                    <Switch
                      checked={userData?.autoRenew}
                      onChange={handleAutoRenew}
                    ></Switch>
                  </div>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="row">
            <div className="col-12 mb-4 sub-center">
              {user?.is_free_trail_used || user.is_free_trail ? (
                <></>
              ) : (
                <>
                  {!isSubscribed ? (
                    <div className="px-3">
                      <Button
                        className="btn btn-dark w-100 btn-bordered"
                        onClick={() => {
                          setCheckFree("is_free");
                          setSubscribeModal(true);
                        }}
                      >
                        Start 14 Days Free Trial
                      </Button>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              )}

              {!isSubscribed ? (
                <div className="px-3">
                  <Button
                    className="btn btn-info w-100 mt-2 btn-bordered"
                    onClick={() => {
                      setCheckFree("subscribe");
                      setSubscribeModal(true);
                    }}
                  >
                    Subscribe
                  </Button>
                </div>
              ) : null}

              {userData.isCancelledSubscription === false ? (
                <>
                  {isSubscribed ? (
                    <div className="px-3 mt-3">
                      <Button
                        className="btn btn-dark w-100 btn-bordered"
                        onClick={() => {
                          setCancelModal(true);
                        }}
                      >
                        Cancel Subscription
                      </Button>
                    </div>
                  ) : null}
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        {cancelModal === true ? (
          <Modal backdrop={true} isOpen={cancelModal} centered>
            <ConformationModalUser
              isOpen={cancelModal}
              onClose={() => setCancelModal(false)}
              confirmText={"Cancel Subscription"}
              cancelBtnBsStyle=" modalcancelbutton btn-secondary"
              message={"Are you sure you want to Cancel Subscription?"}
              handleConfirm={() => cancelSubscription()}
              modalPurpose={"alert"}
            />
          </Modal>
        ) : null}
        {subscribeModal === true ? (
          <Modal isOpen={subscribeModal} backdrop={true} centered>
            {subscribeModal ? (
              <>
                <ModalHeader
                  toggle={() => {
                    setSubscribeModal(false);
                  }}
                >
                  <h4>Subscription confirmation</h4>
                </ModalHeader>
                <ModalBody>
                  <div className="row">
                    <div className="col-12">
                      <div className="name-price-row">
                        <p>
                          <span>Subscription Name:</span>
                          <b>{subData.name}</b>
                        </p>
                        <p>
                          <span>Subscription price:</span>
                          <b>${(subData.price / 100).toFixed(0)}</b>
                        </p>
                      </div>
                    </div>
                    <p className="title_suscription mt-2 ml-2 pl-2">
                      Are you sure you want to suscribe to this package?
                    </p>
                  </div>
                  <div className="row">
                    <div className="col-6 text-center mt-4 pr-2">
                      <Button
                        onClick={() => buySubscription()}
                        className="btn btn-info w-100 btn-bordered"
                        type="button"
                      >
                        Subscribe
                      </Button>
                    </div>
                    <div className="col-6 text-center mt-4 pl-2">
                      <Button
                        onClick={() => setSubscribeModal(false)}
                        className="btn btn-dark w-100 btn-bordered"
                        type="button"
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </ModalBody>
              </>
            ) : (
              <></>
            )}
          </Modal>
        ) : (
          <></>
        )}
        {checkoutModal ? (
          <Modal
            isOpen={checkoutModal}
            backdrop={true}
            centered
            className="modal-lg"
          >
            <CheckoutSubscriptionForm
              closeModal={() => setCheckOutModal(false)}
            />
          </Modal>
        ) : null}

        {loading && <Loader />}
      </div>
    </>
  );
}
const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, { success, error, setUser, check })
)(SubscriptionPage);
